
import HomePage from '../pages/home.f7.html';
import AboutPage from '../pages/about.f7.html';
import ProfilePage from '../pages/profile.f7.html';
import PreferencesPage from '../pages/preferences.f7.html';

import AnalysisPage from '../pages/analysis.f7.html';
import ChaptersPage from '../pages/chapters.f7.html';
import LecturesPage from '../pages/lectures.f7.html';
import NotesPage from '../pages/notes.f7.html';
import QuizPage from '../pages/quiz.f7.html';

import NotFoundPage from '../pages/404.f7.html';

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/profile/',
    component: ProfilePage,
  },
  {
    path: '/analysis/',
    component: AnalysisPage,
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/chapters/',
    component: ChaptersPage,
  },
  {
    "path": "/history/",
    "name": "history",
    "component": ChaptersPage,
    "options": {
      "context": {
        "title": "History",
        "chapters": "hischapters"
      }
    }
  },
  {
    "path": "/geography/",
    "name": "Geography",
    "component": ChaptersPage,
    "options": {
      "context": {
        "title": "Geography",
        "chapters": "geochapters"
      }
    }
  },
  {
    "path": "/politicalscience/",
    "name": "PoliticalScience",
    "component": ChaptersPage,
    "options": {
      "context": {
        "title": "Political Science",
        "chapters": "polchapters"
      }
    }
  },
  {
    "path": "/economics/",
    "name": "Economics",
    "component": ChaptersPage,
    "options": {
      "context": {
        "title": "Economics",
        "chapters": "ecochapters"
      }
    }
  },
  {
    "path": "/lecture/:title/",
    "name": "Lecture",
    "component": LecturesPage,
    "options": {
      "context": {
        "title": "foo",
      }
    }
  },
  {
    path: '/notes/',
    name: 'Notes',
    component: NotesPage,
  },
  {
    path: '/quiz/',
    component: QuizPage,
  },
  {
    path: '/preferences/',
    component:PreferencesPage,
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;